module.exports = __webpack_public_path__ + "static/media/calendar-5.ca75097f.svg";